module.exports = __webpack_public_path__ + "img/plaquette1.27ca666d.jpg";